/*  ==========================================================================
    DYNFORMS CONFIG
    ========================================================================== */

/*
 * IMPORTS
 */

import $ from 'jquery';
import * as vars from '../../globals/variables';
import {params} from './params/params';
import {initDynform} from "./init";

/*
 * YOUR CODE
 */

// add new dynform here
let dynForms = {
    'std_request_2017': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        validationPopup: false,
        // additionals: true,
        colors: {
            'color1': vars.dynformsColors.color2BACKGROUND, //Linie (MAIN)
            'color2': vars.dynformsColors.colorSECONDARY, // (TEXT)
            'color3': vars.dynformsColors.colorPRIMARY, //button background (MAIN)
            'color4': vars.dynformsColors.colorSECONDARY, // (TEXT)
            'color5': vars.dynformsColors.colorTEXT, // button font color
            'color6': vars.dynformsColors.colorPRIMARY, // consent font color (MAIN)
            'colorValid': vars.dynformsColors.colorValid,
            'colorError': vars.dynformsColors.colorError
        },
        offer_id: params.offer,
        last_minute: params.lastminute_code,
        roomcodes: params.roomcodes,
        fieldOverride: {
            fromdate: params.fromdate,
            todate: params.todate
        },
        onFormReady: function () {
            const container = document.getElementById(this.formContainerId);
            if(container.classList.contains('offer_popup') || container.classList.contains('request_popup')) {
                let slider = container.closest('.slick-list');
                slider.style.height = "auto";
            }

        }
    },
    'std_quickrequest_2017': {
        validationPopup: false,
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_quick_request + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorBACKGROUND,
            'color2': vars.dynformsColors.colorTEXT,
            'color3': vars.dynformsColors.colorPRIMARY,
            'color4': vars.dynformsColors.colorBUTTON,
            'colorValid': vars.dynformsColors.colorValid,
            'colorError': vars.dynformsColors.colorError
        }
    },
    'std_newsletter_2017': {
        validationPopup: false,
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_newsletter + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorTEXT,
            'color2': vars.dynformsColors.color2BACKGROUND,
            'color3': vars.dynformsColors.color2BACKGROUND,
            'colorValid': vars.dynformsColors.colorValid,
            'colorError': vars.dynformsColors.colorError
        },
        onFormReady: function () {
            if (vars.$body.hasClass('uid42')) {
                const newsletter = document.getElementsByClassName('bn-f-center__newsletter')[0].parentElement
                const content = document.getElementById('bn-main')
                console.log(newsletter)
                console.log(content)
                console.log(newsletter.length)
                if (newsletter) {
                    content.appendChild(newsletter);
                }
            }
        },
    },
    'bn_newsletter2': {
        validationPopup: false,
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_newsletter + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorTEXT,
            'color2': vars.dynformsColors.colorPRIMARY,
            'color3': '#ffffff',
            'colorValid': vars.dynformsColors.colorValid,
            'colorError': vars.dynformsColors.colorError
        },
        onFormReady: function () {
            if (vars.$body.hasClass('uid42')) {
                const newsletter = document.getElementsByClassName('bn-f-center__newsletter')[0].parentElement
                const content = document.getElementById('bn-main')
                console.log(newsletter)
                console.log(content)
                console.log(newsletter.length)
                if (newsletter) {
                    content.appendChild(newsletter);
                }
            }
        },
    }
};

export {
    dynForms
}



// WEBPACK FOOTER //
// ./source/js/ehotelier/dynforms/config.js